import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'
import { MoreVertical, Phone, CalendarPlus, HandCoins } from 'lucide-react'
import type { DonorRow } from './DonorColumns'

// The task subject prefill expects the full registered class name
// (resolved via the type registry in tasks_controller#prefill_from_query),
// whereas the donation prefill uses the short donor_type token. Map the
// row's donor_type to both forms here.
const SUBJECT_TYPE_BY_DONOR_TYPE: Record<DonorRow['donor_type'], string> = {
  individual: 'CrmPeople::IndividualDonor',
  organization: 'CrmPeople::OrganizationDonor',
}

export function DonorActions({ donor }: { donor: DonorRow }) {
  const subjectType = SUBJECT_TYPE_BY_DONOR_TYPE[donor.donor_type]
  const taskHref = (taskType: 'call' | 'meeting') =>
    `/work/tasks/new?subject_type=${encodeURIComponent(subjectType)}` +
    `&subject_id=${donor.id}&task_type=${taskType}`
  const donationHref =
    `/fundraising/donations?prefill_donor_type=${donor.donor_type}&prefill_donor_id=${donor.id}`

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="size-7 shrink-0"
          onClick={(e) => e.stopPropagation()}
        >
          <MoreVertical className="size-4" />
          <span className="sr-only">Actions pour {donor.name}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" onClick={(e) => e.stopPropagation()}>
        <DropdownMenuItem asChild className="flex items-center gap-2">
          <a href={taskHref('call')}>
            <Phone className="size-4" />
            Nouvel appel
          </a>
        </DropdownMenuItem>
        <DropdownMenuItem asChild className="flex items-center gap-2">
          <a href={taskHref('meeting')}>
            <CalendarPlus className="size-4" />
            Nouveau rendez-vous
          </a>
        </DropdownMenuItem>
        <DropdownMenuItem asChild className="flex items-center gap-2">
          <a href={donationHref}>
            <HandCoins className="size-4" />
            Nouveau don
          </a>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
